// extracted by mini-css-extract-plugin
export var disabled = "_bx-5";
export var fileName = "_bx-b";
export var filePreview = "_bx-4";
export var hoverFilter = "_bx-6";
export var imageButton = "_bx-3 _bx-6";
export var imageButtonContainer = "_bx-2";
export var input = "_bx-7";
export var removeButton = "_bx-0";
export var removeButtonFile = "_bx-1";
export var spinner = "_bx-9";
export var spinnerContainer = "_bx-8";
export var videoContainer = "_bx-a _bx-6";